// @flow

import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import { log } from '../../utils/jsUtils';

import IntegrationsHeader from './IntegrationsHeader';
import IntegrationsContent from './IntegrationsContent';
import MemberDrawer from '../MemberDrawer/index';

import { createClasses } from '../../utils/stylesUtils';
import sharedLayoutStyles from '../Styles/SharedLayoutStyles.Style';

type Props = {};

const IntegrationsHome = (props: Props) => {
  const theme = useTheme();
  const classes = createClasses(sharedLayoutStyles, theme);

  const [mobileOpen, setMobileOpen] = useState(false);

  const usehandleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  return (
    <Box sx={classes.homeRoot}>
      <Helmet>
        <title>Neo | Integrations</title>
      </Helmet>
      <IntegrationsHeader
        mobileOpen={mobileOpen}
        usehandleDrawerToggle={usehandleDrawerToggle}
      />
      
      <MemberDrawer 
        mobileOpen={mobileOpen} 
        usehandleDrawerToggle={usehandleDrawerToggle}
      />

      <IntegrationsContent />
    </Box>
  );
};

export default IntegrationsHome;

